import { useDispatch, useSelector } from 'react-redux'
import { fetchAdWatchesNewCount } from './reduxBit/actions'

import { useInterval } from './useInterval'

const AdWatchesCountPoller = () => {
  const dispatch = useDispatch()
  const { loggedIn } = useSelector((state) => state.user)

  useInterval(() => {
    if (loggedIn) {
      dispatch(fetchAdWatchesNewCount())
    }
  }, 300000)
  return null
}

export default AdWatchesCountPoller
